export enum Modes {
  MFE = 'mfe',
  STANDALONE = 'standalone',
  EMBEDDED = 'embedded',
  ISFORTYPWIDGET = 'isForTypWidget',
}
